export const origin = import.meta.env.VITE_APP_ORIGIN;

export const basePath = `${import.meta.env.VITE_API_URL}/api`;
export const botPath = `${import.meta.env.VITE_BOT_URL}/game`;

export const localizeUuid = 'b7509448acdf45278b2a31585d640615';
export const localizePath = 'https://cdn.simplelocalize.io';

export const cdn = import.meta.env.VITE_CDN_URL;

export const tokenMaxAge = 10; // min
export const tokenMinAge = 9; // min

export const whiteList: string[] = ['109164484', '301366553'];
